import styled, { css } from 'styled-components';

export const Container = styled.div`
  padding: 0;
  margin: 0;
`;

export const CodeValidatorDescription = styled.div`
  text-align: center;
  color: rgb(35, 43, 51);
  font-family: Rubik, sans-serif;
  font-size: ${(props) => props.fontSize};
  line-height: 20px;
  letter-spacing: 0px;
  font-weight: 400;
  opacity: 1;
  color: ${({ theme: { palette } }) => palette.gray3};
  padding: 0 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 280px;
  margin: 0 auto;
`;

export const UnblockButton = styled.button`
  /* width: ${(props) => props.width}; */
  ${(props) =>
    props.codeValidator
      ? `
  width: 295px;

  @media (min-width: 760px) {
    width: 449px;
  }
  `
      : `width: ${props.width};`}
  height: ${(props) => props.height};
  display: inline-flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  color: ${({ theme: { palette } }) => palette.white};
  background-color: ${({ theme: { palette } }) => palette.primary.main};
  text-align: center;
  font-family: 'Rubik';
  font-weight: 500;
  font-size: ${(props) => props.fontSize};
  line-height: 20px;
  border-top-width: initial;
  border-right-width: initial;
  border-left-width: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-left-color: initial;
  user-select: none;
  cursor: pointer;
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 8px;
  border-style: none none solid;
  border-image: initial;
  border-bottom: 2px solid rgba(0, 0, 0, 0.12);
  outline: none;
  transition: all 0.3s ease 0s;

  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'initial')};
  ${(props) =>
    props.isDisabled
      ? `
    background-color: #2493EB !important;
    cursor: not-allowed !important;
    opacity: 0.5;
  `
      : ''}
`;

export const ErrorInfo = styled.p`
  color: ${({ theme: { palette } }) => palette.danger.main};
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  font-weight: 400;
  opacity: 1;
  margin-top: ${({ theme: { spacing } }) => spacing.small};
`;
